import React from 'react';
import { Images, PermissionList, RolePermission, tagEnums } from 'utils';
import { IconAndTitle, TextRow, FilterTags, TagComponent, DateRow, EditWithIcon, LocalDateRow } from 'components';
import { canReadTags } from 'store/tags/tag.utils';
import moment from 'moment';

// A function, not a top-level array, so permissions are read at RENDER time. Permissions are written
// to storage by an async saga after login; evaluating them at module-load time captures an empty
// snapshot and drops the gated columns until a full page reload (see utils/hooks/rolePermissions.js).
export const resourceHead = () => [
    // { name: 'name', searchKey: 'name', title: 'Folder Name', custom: false },
    { name: 'name', title: 'Folder Name', custom: false },
    canReadTags() && { name: '', title: 'Tags', custom: false, renderView: <FilterTags /> },
    { name: 'createdDate', title: 'Created Date', disabled: true, custom: false },
    { name: 'lastUpdated', title: 'Last Updated', disabled: true, custom: false },
    { name: 'shared', title: 'Shared With', disabled: true, custom: false },
    RolePermission([PermissionList.MANAGE_RESOURCE?.code]) && {
        name: 'actions',
        title: 'Actions',
        disabled: true,
        custom: false,
        width: '100px',
    },
];

export const resourceBody = (renderParams) => [
    {
        rowText: (item) => <IconAndTitle icon={Images.folderIcon} title={item?.name} textWidth={10} imgClass="folder-icon-box" />,
    },
    canReadTags() && {
        rowText: (item) => <TagComponent userInfo={item} module={tagEnums.RESOURCE} requestParams={renderParams} />,
        notClickable: true,
    },
    {
        rowText: (item) => (
            <div>
                <LocalDateRow date={item?.createdAt} />
                <TextRow name={item?.createdByFullName} />

                {/*<DateRow date={item?.createdAt} />*/}
                {/*<TextRow name={`${moment(item?.createdAt).format('hh:mm a')} by ${item?.createdByFullName}`} />*/}
            </div>
        ),
    },
    {
        rowText: (item) =>
            item?.updatedAt && item?.updatedByFullName ? (
                <div>
                    <LocalDateRow date={item?.updatedAt} />
                    <TextRow name={item?.updatedByFullName} />

                    {/*<DateRow date={item?.updatedAt} />*/}
                    {/*<TextRow name={`${moment(item?.updatedAt).format('hh:mm a')} by ${item?.updatedByFullName}`} />*/}
                </div>
            ) : (
                '--'
            ),
    },
    {
        rowText: (item) => renderSharedWidth(item),
    },
    RolePermission([PermissionList.MANAGE_RESOURCE?.code]) && {
        button: (fn) => (
            <div className="flex-align-center" style={{ gap: 16 }}>
                <EditWithIcon handleClick={() => fn('edit')} />
                <EditWithIcon handleClick={() => fn('delete')} icon={Images.redTrash} />
            </div>
        ),
        notClickable: true,
    },
];

export const ACTION_TYPE = 'GET_RESOURCE';
export const GET_SINGLE_ACTION_TYPE = 'GET_RESOURCE_BY_ID';

export const resourceNotYet = {
    title: RolePermission([PermissionList.MANAGE_RESOURCE?.code]) ? 'No Resources Added Yet' : 'No Folders Shared With You',
    subTitle: RolePermission([PermissionList.MANAGE_RESOURCE?.code]) ? '' : 'Start adding your resources.',
    image: Images.noFsYet,
};

const renderSharedWidth = (item) => {
    const sharedWith = item?.sharedWith || [];
    const total = sharedWith.length;

    if (total === 0) return '--';

    const visibleUsers = sharedWith.slice(0, 5);
    const extraCount = total - 5;

    return (
        <div className="info-and-avatar">
            {visibleUsers.map((user, index) => (
                <div className="resource-avatar-box" key={index} style={{ marginLeft: index === 0 ? 0 : '-18px' }}>
                    {user?.staffAvatar ? (
                        <img src={user.staffAvatar} alt="avatar" />
                    ) : (
                        `${user?.staffFirstName?.[0] || ''}${user?.staffLastName?.[0] || ''}`
                    )}
                </div>
            ))}

            {extraCount > 0 && (
                <div className="resource-avatar-box" style={{ marginLeft: '-18px' }}>
                    +{extraCount}
                </div>
            )}
        </div>
    );
};
